import { createReducer } from '@reduxjs/toolkit';
import { setReferencedRecord } from 'actions/referencedRecords';
import { DateTime } from 'luxon';
import { ReferencedRecordsState } from 'types';

const defaultState: ReferencedRecordsState = {};

const referencedRecordsReducer = createReducer(defaultState, (builder) =>
  builder.addCase(setReferencedRecord, (state, { payload }) => {
    const { referenceField, referenceKey, record } = payload;
    if (!state[referenceField]) {
      state[referenceField] = {};
    }
    state[referenceField][referenceKey] = {
      record,
      time: DateTime.now().toISO() as string,
    };
  }),
);

export default referencedRecordsReducer;
